import { Befehl5 } from '../../../models'
import { BefehlAuftrag_5_41Dto, BefehlAuftrag_5_95Dto } from '../../../dtos'

import { Befehl5FormData, Befehl5FormSchema } from './schema'
import { Befehl5DataDto } from '../../../dtos/befehl-5-dto'
import {
  createFreitextAuftrag,
  createKmhField,
  createLocationField,
  createZugmeldestelleField
} from '../converter-utils'

export const convertModelToBefehl5FormData = (
  befehl?: Befehl5
): Befehl5FormData => {
  const formData = Befehl5FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  for (const auftrag of befehl.auftraege) {
    switch (auftrag.kennung) {
      case '5.41': {
        handleAuftrag_5_41(auftrag, formData)
        break
      }
      case '5.95': {
        handleAuftrag_5_95(auftrag, formData)
        break
      }
    }
  }

  return formData
}

function handleAuftrag_5_41(
  auftrag541: BefehlAuftrag_5_41Dto,
  formData: Befehl5FormData
) {
  // enabled not changeable by user
  formData.auftrag_5_41.enabled = true

  if (!auftrag541.felder) {
    return
  }

  const feld5421 = auftrag541.felder.find((f) => f.kennung === '5.42.1')
  const feld543 = auftrag541.felder.find((f) => f.kennung === '5.43')
  const feld544 = auftrag541.felder.find((f) => f.kennung === '5.44')
  const feld5471 = auftrag541.felder.find((f) => f.kennung === '5.47.1')
  const feld5472 = auftrag541.felder.find((f) => f.kennung === '5.47.2')
  const feld5481 = auftrag541.felder.find((f) => f.kennung === '5.48.1')
  const feld5482 = auftrag541.felder.find((f) => f.kennung === '5.48.2')

  // Extract speed field (5.42.1)
  if (feld5421?.werte?.kmh) {
    formData.auftrag_5_41.feld_5_42_1_kmh = feld5421.werte.kmh
  }

  // Determine selector based on presence of fields
  if (feld543 && feld544) {
    formData.auftrag_5_41.selector = 'zwischen'
  } else if (feld543) {
    formData.auftrag_5_41.selector = 'in'
  }

  // Extract zugmeldestelle fields
  if (feld543?.werte?.zugmeldestelle) {
    formData.auftrag_5_41.feld_5_43_zugmeldestelle = {
      art: feld543.werte.zugmeldestelle.art || '',
      name: feld543.werte.zugmeldestelle.name || ''
    }
  }

  if (feld544?.werte?.zugmeldestelle) {
    formData.auftrag_5_41.feld_5_44_zugmeldestelle = {
      art: feld544.werte.zugmeldestelle.art || '',
      name: feld544.werte.zugmeldestelle.name || ''
    }
  }
  // Extract location fields (5.47)
  if (feld5471?.werte) {
    formData.auftrag_5_41.feld_5_47_type = 'km'
    formData.auftrag_5_41.feld_5_47_1_km = feld5471.werte.km
  } else if (feld5472?.werte) {
    formData.auftrag_5_41.feld_5_47_type = 'signal'
    formData.auftrag_5_41.feld_5_47_2_signal = feld5472.werte.signal
  }

  // Extract location fields (5.48)
  if (feld5481?.werte) {
    formData.auftrag_5_41.feld_5_48_type = 'km'
    formData.auftrag_5_41.feld_5_48_1_km = feld5481.werte.km
  } else if (feld5482?.werte) {
    formData.auftrag_5_41.feld_5_48_type = 'signal'
    formData.auftrag_5_41.feld_5_48_2_signal = feld5482.werte.signal
  }
}

function handleAuftrag_5_95(
  auftrag595: BefehlAuftrag_5_95Dto,
  formData: Befehl5FormData
) {
  formData.auftrag_5_95.enabled = true

  for (const feld of auftrag595.felder) {
    if (feld.kennung === '5.96') {
      const feld596 = feld
      formData.auftrag_5_95.freitext = feld596.werte.freitext || ''
    }
  }
}

export const convertBefehl5FormDataToModel = (
  data: Befehl5FormData,
  frontendId: string
): Befehl5 => {
  const auftraege: Befehl5DataDto = []

  if (data.auftrag_5_41?.enabled) {
    const fields = []

    fields.push(createKmhField('5.42.1', data.auftrag_5_41?.feld_5_42_1_kmh))

    if (
      data.auftrag_5_41?.selector === 'in' ||
      data.auftrag_5_41?.selector === 'zwischen'
    ) {
      fields.push(
        createZugmeldestelleField(
          '5.43',
          data.auftrag_5_41?.feld_5_43_zugmeldestelle?.art,
          data.auftrag_5_41?.feld_5_43_zugmeldestelle?.name
        )
      )
    }

    if (data.auftrag_5_41?.selector === 'zwischen') {
      fields.push(
        createZugmeldestelleField(
          '5.44',
          data.auftrag_5_41?.feld_5_44_zugmeldestelle?.art,
          data.auftrag_5_41?.feld_5_44_zugmeldestelle?.name
        )
      )
    }

    const feld547 = createLocationField(
      '5.47',
      data.auftrag_5_41?.feld_5_47_type,
      data.auftrag_5_41?.feld_5_47_1_km,
      data.auftrag_5_41?.feld_5_47_2_signal
    )
    if (feld547) {
      fields.push(feld547)
    }

    const feld548 = createLocationField(
      '5.48',
      data.auftrag_5_41?.feld_5_48_type,
      data.auftrag_5_41?.feld_5_48_1_km,
      data.auftrag_5_41?.feld_5_48_2_signal
    )
    if (feld548) {
      fields.push(feld548)
    }

    auftraege.push({
      kennung: '5.41',
      felder: fields
    } as BefehlAuftrag_5_41Dto)
  }
  if (data.auftrag_5_95?.enabled) {
    const freitextAuftrag = createFreitextAuftrag(
      '5',
      true,
      data.auftrag_5_95?.freitext ?? ''
    )
    if (freitextAuftrag) {
      auftraege.push(freitextAuftrag as BefehlAuftrag_5_95Dto)
    }
  }

  return {
    kennung: '5',
    frontendId,
    auftraege
  }
}
